const initialState = "";
const bidreducer = (state = initialState, action ) => {
    switch (action.type) {
        case "BID":
      return action.data;
    default:
      return state;
    }
}

export default bidreducer;
